import React, { useRef, useImperativeHandle, forwardRef } from 'react'; //RITM1258665
import Form from "react-jsonschema-form";
import { Button } from 'carbon-components-react';
import { default as customWidgets } from './customwidget'
//import RTEField from "react-jsonschema-form-extras/lib/RTEField"; //RITM1396424
//import fields from "react-jsonschema-form-extras";
/*RITM1258665 Start*/
const JSForm = forwardRef((props, ref) => {
    const formRef = useRef();
 
    const hiddenSubmitRef = useRef();
    useImperativeHandle(ref, () => ({
      submit: () => {
        if (hiddenSubmitRef.current) {
          hiddenSubmitRef.current.click();
        }
      }
    }));
    /*RITM1258665 End*/
    function transformErrors(errors) {
        return errors.map(error => {
            if (error.name === "required") {
                error.message = "Required Field"
            }
            return error;
        });
    }

    const customFormats = {
        'guid': /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
    };

    //const additionalMetaSchemas = require("ajv/lib/refs/json-schema-draft-04.json");

    function validate(formData, errors) {
        if ("validSince" in formData && "validUntil" in formData) {
            if (formData.validSince != null && formData.validUntil != null &&
                Date.parse(formData.validSince) > Date.parse(formData.validUntil)) {
                errors.validUntil.addError("Valid Until should be greater than Valid Since");
            }
        }
        return errors;
    }


    return (
        <div className="bx--grid bx--col-lg-16" >
            <Form
                //fields={{ rte: RTEField }} //RITM1396424
                fields={{}} //RITM1396424
                widgets={customWidgets}
                customFormats={customFormats}
                //additionalMetaSchemas={[additionalMetaSchemas]}
                validate={validate}
                //noValidate ={true}
                liveValidate={false}
                showErrorList={false}
                transformErrors={transformErrors}
                ref={ref} //RITM1258665
                {...props} //RITM1258665
                className="bx--row dyn-custom-form">
                      {/* RITM1258665 This ensures there's a submit button in the form's DOM */}
                <button
                  type="submit"
                  ref={hiddenSubmitRef}
                  style={{ display: "none" }}
                />
                <div>
                    {props.showButton &&
                        <div className={`bx--btn-set`}>
                            <Button kind="primary" type="submit">
                                Submit
                            </Button>
                            <Button kind="secondary" >
                                Cancel
                            </Button>
                        </div>

                    }
                </div>
            </Form>
        </div>);
}); //RITM1258665
export default JSForm; //RITM1258665
